/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ThumbImage_photo = {
    readonly placeholder: string | null;
    readonly smallPath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $refType": "ThumbImage_photo";
};
export type ThumbImage_photo$data = ThumbImage_photo;
export type ThumbImage_photo$key = {
    readonly " $data"?: ThumbImage_photo$data;
    readonly " $fragmentRefs": FragmentRefs<"ThumbImage_photo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ThumbImage_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};
(node as any).hash = '2bad54802e184ba5b9be1f4cab3de2e0';
export default node;
